const SET_LOADING = "SET_LOADING";

export const ACTION_SET_LOADING = "setLoading";

export const STATE = {
  show_loading: false
};

export const ACTION = {
  LOADING: ({ commit }, data = false) => {
    commit(SET_LOADING, data);
  }
};

export const GETTER = {
  LOADING: state => {
    return state.STATE_OTHER.show_loading;
  }
};

export const MUTATION = {
  SET_LOADING: (state, value) => {
    state.STATE_OTHER.show_loading = value;
  }
};



// WEBPACK FOOTER //
// ./src/store/repo/others.js